import { useEffect, useState } from "react";
import { ContentHeader } from "../../components";
import { toast } from "react-toastify";
import { Col, DatePicker, Form, Row, Table, Tabs } from "antd";
import { dateCommon, formatVND, validateMessages } from '../../helpers/common';
import { useDispatch } from 'react-redux';
import { hideLoadingScreen, showLoadingScreen } from '../../store/reducers/loading';
import { TongHopThueKTXNamResponse } from '../../models/thue/Thue';
import dayjs from 'dayjs';
import { ColumnsType } from 'antd/es/table';
import { layLayDuLieuTongHopThueKTXTheoNam } from '../../services/thue';

const TongHopThueKTXTheoNam = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [form] = Form.useForm();
    const [dataThueTNCN, setDataThueTNCN] = useState<Array<TongHopThueKTXNamResponse>>([]);
    const dispatch = useDispatch();

    const layThueThang = async (nam: number) => {
        dispatch(showLoadingScreen());
        try {
            setIsLoading(true);
            var data = await layLayDuLieuTongHopThueKTXTheoNam(nam);

            setIsLoading(false);
            setDataThueTNCN(data);
        }
        catch (error: any) {
            toast.error(error?.message || `Lấy dữ liệu tổng hợp thuế không thường xuyên năm ${nam} không thành công`);
            setIsLoading(false);
            setDataThueTNCN([]);
        }
        dispatch(hideLoadingScreen());        
    }

    const dynamicColumns = dataThueTNCN?.length > 0 ? (dataThueTNCN?.find(x => x?.chiTietThueHangThang?.length === Math.max(...dataThueTNCN?.map(y => y?.chiTietThueHangThang?.length))) || dataThueTNCN[0]).chiTietThueHangThang?.map((item, index) => ({
        title: item?.tenThuNhap,
        dataIndex: `chiTietThueHangThang_${item?.tenThuNhap}_${index}`,
        key: `chiTietThueHangThang_${item?.tenThuNhap}_${index}`,
        className: 'custom-column',
        render: (text: any, record: TongHopThueKTXNamResponse) => formatVND(record?.chiTietThueHangThang?.find((i) => i?.tenThuNhap === item?.tenThuNhap)?.mucThuNhap),
    })) : [];

    const columns: ColumnsType<TongHopThueKTXNamResponse> = [
        { title: 'Họ Tên', dataIndex: 'hoTen', key: 'hoTen', fixed: 'left' },
        { title: 'Chức vụ', dataIndex: 'tenChucVu', key: 'tenChucVu', fixed: 'left' },
        ...dynamicColumns,
        {
            title: 'Tổng cộng',
            dataIndex: 'tongCong',
            key: 'tongCong',
            className: 'custom-column',
            render: (text: number) => formatVND(text),
        },
        {
            title: 'Thuế TNCN 10%',
            dataIndex: 'thueTNCN',
            key: 'thueTNCN',
            className: 'custom-column',
            render: (text: number) => formatVND(text),
        },
    ];

    useEffect(() => {
        var now = new Date();
        form.setFieldsValue({
            thoiGianThueThang: dayjs(dateCommon.formatDate(now, "yyyy"), "YYYY")
        })
        layThueThang(now.getFullYear());
    }, []);    

    return <section>
        <ContentHeader title="Bảng tổng hợp Thuế TNCN không thường xuyên" />
        <Tabs
            defaultActiveKey="1" items={[
                {
                    key: "1",
                    label: "Tổng hợp Thuế TNCN không thường xuyên theo năm",
                    children:
                        <Row>
                            <Col span="24" className="card card-body">
                                <Form
                                    layout="vertical"
                                    validateMessages={validateMessages}
                                    form={form}
                                >
                                    <Row gutter={12}>
                                        <Col span="6">
                                            <Form.Item rules={[
                                                {
                                                    required: true
                                                },
                                            ]} label="Năm" name="thoiGianThueThang">
                                                <DatePicker
                                                    onChange={(value, dateString) => {
                                                        layThueThang(isNaN(parseInt(dateString)) ? (new Date()).getFullYear() : parseInt(dateString)) 
                                                    }}
                                                    allowClear={false}
                                                    changeOnBlur={true}
                                                    style={{ width: "100%" }}
                                                    format={["YYYY", "YYYY"]}
                                                    placeholder="Chọn thời gian"
                                                    picker="year" />
                                            </Form.Item>
                                        </Col>
                                    </Row>                                    
                                </Form>
                            </Col>
                        </Row>
                }]} />
        <div className="card card-primary mt-2">
            <Table
                pagination={false}
                dataSource={(dataThueTNCN || []).map((value, index) => { const item = { key: index, ...value }; return item; })}
                loading={isLoading}
                columns={columns}
                rowClassName={(record, index) => {
                    if (record.idNhanSuKhac == 0) {
                        return "bold-row-summary";
                    }
                    return "";
                }}
                sticky
                bordered
                scroll={{ x: 1500 }}
                locale={{ emptyText: "Không có dữ liệu" }}
                summary={pageData => {
                    var totalTongCong = 0;
                    var totalTongThueTNCN = 0;
                    var dataDynamic: number[] = [];
                    var resultArray: number[] = [];
                    const totalByType: { [key: string]: number } = {};
                    pageData.forEach(({ tongCong, chiTietThueHangThang, thueTNCN }) => {
                        totalTongCong += tongCong;
                        totalTongThueTNCN += thueTNCN;

                        resultArray = Object.values(totalByType);

                        chiTietThueHangThang?.forEach((item: any, idx: number) => {
                            if (dataDynamic.length - 1 < idx) {
                                dataDynamic.push(0);
                            }

                            dataDynamic[idx] += item.mucThuNhap;
                        });
                    });
                    var length1 = dataDynamic.length;
                    return (
                        <>
                            <Table.Summary.Row>
                                <Table.Summary.Cell index={0} colSpan={2} align="left"> <label>Tổng cộng</label> </Table.Summary.Cell>
                                {dataDynamic.length > 0 &&
                                    <>
                                    {dataDynamic.map((item: number, idx: number) => (
                                        <Table.Summary.Cell key={"chiTietHangThangDynamic" + idx} index={2 + idx} align="right"><label> {formatVND(item)}</label></Table.Summary.Cell>
                                        ))}
                                    </>
                                }
                                <Table.Summary.Cell index={3 + length1} align="right"> <label>{formatVND(totalTongCong) || "-"} </label> </Table.Summary.Cell>
                                <Table.Summary.Cell index={4 + length1} align="right"> <label>{formatVND(totalTongThueTNCN) || "-"} </label> </Table.Summary.Cell>
                            </Table.Summary.Row>
                        </>
                    );
                }}
            />
        </div>
    </section >
}

export default TongHopThueKTXTheoNam;